import { render } from "./SelectedEra.vue?vue&type=template&id=af1c9b66"
import script from "./SelectedEra.vue?vue&type=script&lang=js"
export * from "./SelectedEra.vue?vue&type=script&lang=js"

import "./SelectedEra.vue?vue&type=style&index=0&id=af1c9b66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__